import { render } from "./MButton.vue?vue&type=template&id=230cc4fe&scoped=true"
import script from "./MButton.vue?vue&type=script&lang=js"
export * from "./MButton.vue?vue&type=script&lang=js"

import "./MButton.vue?vue&type=style&index=0&id=230cc4fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230cc4fe"]])

export default __exports__